<script>
import PageSubmenu from '@/components/PageSubmenu.vue'

export default {
  name: 'ChatsSubmenu',
  components: { PageSubmenu },
  computed: {
    isAdmin () {
      return this.$store.getters.roles.includes('admin')
    },
    links () {
      return [
        {
          label: 'Conversations',
          path: '/app/chats',
          roles: ['admin', 'director', 'community-manager', 'operator']
        },
        {
          label: 'Paramètres messagerie',
          path: '/app/chats/settings',
          roles: ['admin']
        }
      ]
    }
  }
}
</script>

<template>
  <PageSubmenu v-if="isAdmin" :links="links" />
</template>
